import { Component, inject } from '@angular/core';
import { ButtonComponent } from "../../../../shared/button/button.component";
import { BenefitsService } from '@services/benefits.service';
import { isInIframe } from '@helpers/utils/is-in-iframe.util';

@Component({
    selector: 'app-benefits-button',
    imports: [
        ButtonComponent
    ],
    templateUrl: './benefits-button.component.html',
    styleUrl: './benefits-button.component.css',
    // In the iframe topbar (no gradient behind it) the button rests on the brand color.
    host: { '[class.on-brand]': 'iframeMode' }
})
export class BenefitsButtonComponent {

  // SERVICES
  public readonly benefits:    BenefitsService = inject(BenefitsService);

  protected readonly iframeMode: boolean       = isInIframe();

}
